import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.RequestSearchPopup', {
    popupTitle: 'Document Search',
    doneButtonTitle: 'Start document search according to the given criteria.',
    companyFieldTitle: 'Organisation name',
    unnamedOrganisation: 'Unnamed Organisation',
    companyPlaceholder: 'Select organisation',
    templateFieldTitle: 'Request type',
    templatePlaceholder: 'Select request type',
    requestorFieldTitle: 'Requester',
    requestorPlaceholder: 'Select requester',
    dateGreaterEqualsPlaceholder: 'Enter date',
    dateLessEqualsPlaceholder: 'Enter date',
    dateFieldTitle: 'Date',
    dateFromLabel: 'From',
    dateToLabel: 'To',
    requestStatusFieldTitle: 'Request status',
    requestStatusPlaceholder: 'Select request status',
    doneButtonText: 'Search',
    requiredBlockHeader: 'ORGANISATION AND REQUEST TYPE',
    noActiveWorkflowWarningText: 'There are no previously activated workflows or you are not part of them.',
    disconnectionWarningText:
        'Some filters cannot be modified since the company is disconnected from {integrationName}',
    detailsBlockHeader: 'DETAILS',
    approved: 'Approved',
    rejected: 'Rejected',
    cancelled: 'Cancelled',
    onApproval: 'On approval',
    onReview: 'On review',
    onHold: 'On hold',
    emptySearchNotificationText: "Sorry, we didn't find anything.",
});
